import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loading from "components/Spinner";

const NoMatch = lazy(() => import("components/NoMatch"));
const Dashboard = lazy(() => import("pages/Dashboard"));

const RoutesScreen = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesScreen;
